module.exports = __webpack_public_path__ + "img/bingo_ball-22.89d892c5.png";